import { render, staticRenderFns } from "./ChatMyAttDialog.vue?vue&type=template&id=fba26716&scoped=true"
import script from "./ChatMyAttDialog.vue?vue&type=script&lang=js"
export * from "./ChatMyAttDialog.vue?vue&type=script&lang=js"
import style0 from "./ChatMyAttDialog.vue?vue&type=style&index=0&id=fba26716&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fba26716",
  null
  
)

export default component.exports